import {ethers} from 'ethers'

export default async function signBytes(message: string, wallet: ethers.Wallet): Promise<string> {
    const mHash = ethers.utils.solidityKeccak256(['bytes'], [message])
    return await wallet.signMessage(ethers.utils.arrayify(mHash))
}
